import {
  baseAndroidAuthConfig,
  baseIosAuthConfig,
  baseWebAuthConfig,
} from '@sprint-expert-manager/app/core/auth/auth-config';
// noinspection DuplicatedCode
import { AuthConfig } from 'angular-oauth2-oidc';

const webAuthConfig: AuthConfig = {
  ...baseWebAuthConfig,
  issuer: 'https://auth-dev.sprintapp.team/realms/sprint-expert-manager-app',
  userinfoEndpoint:
    'https://auth-dev.sprintapp.team/realms/sprint-expert-manager-app/protocol/openid-connect/userinfo',
  tokenEndpoint:
    'https://auth-dev.sprintapp.team/realms/sprint-expert-manager-app/protocol/openid-connect/token',
  revocationEndpoint:
    'https://auth-dev.sprintapp.team/realms/sprint-expert-manager-app/protocol/openid-connect/revoke',
  logoutUrl:
    'https://auth-dev.sprintapp.team/realms/sprint-expert-manager-app/protocol/openid-connect/logout',
  strictDiscoveryDocumentValidation: true,
  redirectUri: window.location.origin + '/',
  clientId: 'expert-manager',
  showDebugInformation: true,
} as AuthConfig;

const iosAuthConfig = {
  ...baseIosAuthConfig,
  issuer: 'https://auth-dev.sprintapp.team/realms/sprint-expert-manager-app',
  userinfoEndpoint:
    'https://auth-dev.sprintapp.team/realms/sprint-expert-manager-app/protocol/openid-connect/userinfo',
  tokenEndpoint:
    'https://auth-dev.sprintapp.team/realms/sprint-expert-manager-app/protocol/openid-connect/token',
  revocationEndpoint:
    'https://auth-dev.sprintapp.team/realms/sprint-expert-manager-app/protocol/openid-connect/revoke',
  logoutUrl:
    'https://auth-dev.sprintapp.team/realms/sprint-expert-manager-app/protocol/openid-connect/logout',
  strictDiscoveryDocumentValidation: true,
  redirectUri: 'myschema://login',
  clientId: 'expert-manager',
  showDebugInformation: true,
} as AuthConfig;

const androidAuthConfig = {
  ...baseAndroidAuthConfig,
  issuer: 'https://auth-dev.sprintapp.team/realms/sprint-expert-manager-app',
  userinfoEndpoint:
    'https://auth-dev.sprintapp.team/realms/sprint-expert-manager-app/protocol/openid-connect/userinfo',
  tokenEndpoint:
    'https://auth-dev.sprintapp.team/realms/sprint-expert-manager-app/protocol/openid-connect/token',
  revocationEndpoint:
    'https://auth-dev.sprintapp.team/realms/sprint-expert-manager-app/protocol/openid-connect/revoke',
  logoutUrl:
    'https://auth-dev.sprintapp.team/realms/sprint-expert-manager-app/protocol/openid-connect/logout',
  strictDiscoveryDocumentValidation: true,
  redirectUri: 'myschema://login',
  clientId: 'expert-manager',
  showDebugInformation: true,
} as AuthConfig;

export const environment = {
  name: 'Dev',
  title: '스프린트 코치 매니저 - Dev',
  production: false,
  portOne: {
    storeId: 'store-ff34cfe4-7a68-462b-8186-ab26cd43af44',
    channelKey: 'channel-key-600fd58b-dc1f-40a8-bdf4-05622c362224',
    noticeUrls: ['https://api-dev.sprintapp.team/api/port-one/webhook'],
  },
  webUrl: {
    backoffice: 'https://dev.sprintapp.team',
    expert: 'https://expert-dev.sprintapp.team',
    expertManager: 'https://expert-manager-dev.sprintapp.team',
  },
  apiBaseUrl: {
    web: 'https://api-dev.sprintapp.team',
    ios: 'capacitor://localhost',
    android: 'http://localhost',
  },
  authConfig: {
    web: webAuthConfig,
    ios: iosAuthConfig,
    android: androidAuthConfig,
  },
  authAllowedUrls: {
    web: ['https://expert-manager-dev.sprintapp.team/api', 'https://api-dev.sprintapp.team'],
    ios: ['capacitor://localhost/api'],
    android: ['http://localhost/api'],
  },
  streamChat: {
    apiKey: 'f6y3883way8g',
  },
  s3Path: 'https://static-dev.sprintapp.team',
  channelPluginKey: 'e43dc155-7cd9-4b31-ae22-105c0593d857',
  googleCalendarApiKey: 'AIzaSyBEVp4CkV4Y7gCYjaXRAFBOtlo27dN9itQ',
  imageResizeUrl: 'https://image-resize-dev.sprintapp.team',
};
